import { patientReferralConstants } from "./PatientReferralConstants";
import { getReferralsList } from "../../services";

export const referralListProcessing = isProcessing => {
  return {
    type: patientReferralConstants.REFERRALS_LIST_PROCESSING,
    isProcessing
  };
};
export const referralListSuccess = referrals => {
  return { type: patientReferralConstants.REFERRALS_LIST_SUCCESS, referrals };
};
export const totalRecords = totalRecords => {
  return { type: patientReferralConstants.TOTAL_RECORDS_SUCCESS, totalRecords };
};
export const referralListFailure = error => {
  return { type: patientReferralConstants.REFERRALS_LIST_FAILURE, error };
};

/**
 * @function getReferrals
 * @desc Called when coordinator from the dropdown is changed
 */
export const getReferrals = pageNo => {
  return dispatch => {
    dispatch(referralListProcessing(true));
    getReferralsList(pageNo)
      .then(res => {
        dispatch(referralListProcessing(false));
        if (res && res.data.success === true) {
          dispatch(referralListSuccess(res.data.data.referrals));
          dispatch(totalRecords(res.data.data.total_records));
        } else {
          dispatch(referralListFailure(res.message));
        }
      })
      .catch(err => {
        dispatch(referralListProcessing(false));
        dispatch(referralListFailure(err));
      });
  };
};
